import React, { Component } from "react";
import moment from "moment";
export default class EamPaymentApprovalInformation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      paymentDetails: this.props.eamPaymentDetailsInfo,
    };
  }

  async componentDidMount() {
    // let info = this.state.paymentDetails;
    // Object.keys(info).map((key, index) => {
    //   console.log(info[key][0].status);
    // });
  }

  filterStatusTitle = (status) => {
    switch (status) {
      case 18:
        return "Payment Approve";
      case 19:
        return "Payment Receive";
      case 25:
        return "Payment Finish";
      case 28:
        return "Payment Refer Back";
      case 27:
        return "Payment Reject";
      case 31:
        return "Payment Receive Refer Back";
      default:
        return "--";
    }
  };

  render() {
    let info = this.state.paymentDetails;

    return (
      <div className="main-info">
        <div className="header-info col-md-12">
          <h4>Payment Information</h4>
        </div>
        <div
          className=""
          style={{
            marginTop: 20,
            display: "flex",
            flexWrap: "wrap",
            paddingLeft: "70px",
            paddingRight: "70px",
          }}
        >
          {info.map((item, index) => {
            return (
              <div className="col-sm-12 col-md-6 col-lg-4" key={index}>
                <div>
                  <label style={{ color: "#333", fontSize: "14px" }}>
                    {item.status ? this.filterStatusTitle(item.status) : "key"}
                  </label>
                </div>
                <div>
                  <div>
                    <label>{item.fullname ? item.fullname : "-"}</label>
                  </div>
                  <div>
                    <label>
                      {item.employment_id ? item.employment_id : "-"}
                    </label>
                  </div>
                  <div>
                    <label>{item.designations ? item.designations : "-"}</label>
                  </div>
                  <div>
                    <label>{item.branch_name ? item.branch_name : "-"}</label>
                  </div>
                  <div>
                    <label>
                      {item.hrm_payment_action_user_date
                        ? moment
                            .parseZone(item.hrm_payment_action_user_date)
                            .format("YYYY-MM-DD HH:mm:ss")
                        : "-"}
                    </label>
                  </div>
                  <div>
                    <label>
                      {item.hrm_payment_action_comment
                        ? item.hrm_payment_action_comment
                        : "-"}
                    </label>
                  </div>
                  <div style={{ marginBottom: "30px" }}></div>
                </div>
              </div>
            );
          })}
          {/* {Object.keys(info).map((key, index) => {
            return (
              <div
                className="col-sm-12 col-md-6 col-lg-4"
                obj={info[key]}
                key={index}
              >
                {info[key][0] && info[key][0].status ? (
                  <div>
                    <div>
                      <label style={{ color: "#333", fontSize: "14px" }}>
                        {info[key][0].status
                          ? this.filterStatusTitle(info[key][0].status)
                          : key}
                      </label>
                    </div>
                    {info[key].map((item, index_item) => {
                      return (
                        <div obj={item} key={index_item}>
                          <div>
                            <label>{item.fullname ? item.fullname : "-"}</label>
                          </div>
                          <div>
                            <label>
                              {item.employment_id ? item.employment_id : "-"}
                            </label>
                          </div>
                          <div>
                            <label>
                              {item.designations ? item.designations : "-"}
                            </label>
                          </div>
                          <div>
                            <label>
                              {item.branch_name ? item.branch_name : "-"}
                            </label>
                          </div>
                          <div>
                            <label>
                              {item.hrm_payment_action_user_date
                                ? moment
                                    .parseZone(
                                      item.hrm_payment_action_user_date
                                    )
                                    .format("YYYY-MM-DD HH:mm:ss")
                                : "-"}
                            </label>
                          </div>
                          <div>
                            <label>
                              {item.hrm_payment_action_comment
                                ? item.hrm_payment_action_comment
                                : "-"}
                            </label>
                          </div>
                          <div style={{ marginBottom: "30px" }}></div>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div>
                    <div>
                      <label style={{ color: "#333", fontSize: "14px" }}>
                        {key}
                      </label>
                    </div>
                    <div>
                      <div>
                        <label> - </label>
                      </div>
                      <div>
                        <label> - </label>
                      </div>
                      <div>
                        <label> - </label>
                      </div>
                      <div>
                        <label> - </label>
                      </div>
                      <div>
                        <label> - </label>
                      </div>
                      <div>
                        <label> - </label>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            );
          })} */}
        </div>
      </div>
    );
  }
}
